import React, {
    useContext,
    useCallback,
    useState
} from 'react';
import { get } from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import metadata from '../VehiclesPage.metadata.json5';

function VehiclesPage(props) {
    const { wizardData: rewriteVM, updateWizardData, viewOnly } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const [checkScrolling, setCheckScrolling] = useState(false);
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const [availableMakes, setAvailableMakes] = useState({});
    const [availableModels, setAvailableModels] = useState({});
    const [availableSeries, setAvailableSeries] = useState({});

    const {
        onValidate
    } = useValidation('VehiclePage');

    /**
     * Helper callback for handling navigation to the next wizard screen.
     */
    const onNext = useCallback(
        () => rewriteVM,
        [rewriteVM]
    );

    /**
     * Define property overrides for this Jutro component.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            readOnly: viewOnly,
            labelPosition: breakpoint === 'top',
        },
        vehiclesPageLoadingIndicator: {
            loaded: true,
        },
        vehiclesPageContainer: {
            visible: true
        },
        eaAddAnotherVehicleButtonContainer: {
            visible: false
        },
        vehicleLookupErrorNotificationDiv: {
            visible: false
        },
        vehicleInformationSubHeaderID: {
            visible: false
        },
        scrollingComponentId: {
            checkScrolling,
            setCheckScrolling,
            scrollableDiv: document.getElementById('eavehiclecontainerID')
        },
        oneCarMinimumNotificationDiv: {
            visible: false
        },
        fieldsClearedInfoMessage: {
            visible: false
        },
        yearVinInvalidInfoMessage: {
            visible: false
        },
        vehicleInfoChangedMessageDiv: {
            visible: false
        },
        EAVehicleGrid: {
            vehicles: get(rewriteVM, 'lobData.personalAuto_EA.coverables.vehicles', []),
            path: 'lobData.personalAuto_EA.coverables.vehicles.children',
            onValidate,
            viewModelService,
            showErrors: false,
            policyState: get(rewriteVM, 'baseData.policyAddress.state.value.code'),
            vehiclePageDisregardFieldValidation: () => {},
            authHeader,
            onValidationChange: onValidate,
            transactionVM: rewriteVM,
            updateWizardData,
            setCheckScrolling,
            addVehicleVM: () => {},
            viewOnlyMode: true,
            availableMakes,
            setAvailableMakes,
            availableModels,
            setAvailableModels,
            availableSeries,
            setAvailableSeries
        }
    };

    /**
     * Define mappings to be used when resolving values for this Jutro component.
     */
    const resolvers = {
        resolveCallbackMap: {
            onAddVehicleClick: () => { },
            onAddAdditionalInterest: () => { },
            onRemoveVehicle: () => { },
            onValidate,
            onPrefillData: () => { },
            onAddSafetyVehicleClick: () => { },
            onAddTemporarySafetyVM: () => { },
        }
    };

    /**
     * Helper callback for reading values from the view model.
     */
    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, rewriteVM, id, path, overrideProps),
        [rewriteVM, overrideProps]
    );

    /**
     * Define rendering behaviors for this Jutro component.
     */
    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={rewriteVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

VehiclesPage.propTypes = wizardProps;
export default VehiclesPage;
